import { ChatFile } from '@/shared/types/files'

import { DraftMessage, DraftMessageLocal } from '../model/types'

export const transformLocalDraftToDraftMessage = (draftLocalMessage: DraftMessageLocal, files?: ChatFile[]): DraftMessage => {
  return {
    pServed: draftLocalMessage.pServed,
    files: files!,
    timestamp: draftLocalMessage.timestamp!,
    messageText: draftLocalMessage.messageText!,
    quotedEventId: draftLocalMessage.quotedEventId!,
  }
}
